<script lang="ts">
  import type { Facility, FacilityCode } from '@bruce/api/common/facility'
  import Icon from './base/Icon.svelte'

  export let facility: Facility

  function facilityCodeToIcon(code: FacilityCode) {
    switch (code) {
      case 'changing':
        return 'ph-coat-hanger'
      case 'locker':
        return 'ph-lockers'
      case 'parking':
        return 'ph-letter-circle-p'
      case 'sauna':
        return 'ph-thermometer-hot'
      case 'shower':
        return 'ph-shower'
      case 'towel':
        return 'ph-towel'
    }
  }
</script>

<div class="badge">
  <Icon icon={facilityCodeToIcon(facility.code)} />
  {facility.title}
</div>

<style lang="scss">
  .badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    font-weight: 500;
    padding: 0.25em 0.5em;
    max-width: max-content;
  }
</style>
